import { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import { articles } from '@/mocks/homeData';

const articleContent: Record<string, {
  content: string;
  tags: string[];
  relatedArticles: string[];
}> = {
  a1: {
    content: `2026年，中国电影市场将迎来一波重磅作品。从科幻巨制到现实主义佳作，从动画电影到悬疑大片，今年的国产电影阵容堪称豪华。

科幻电影方面，《流浪地球3》无疑是万众瞩目的焦点。在前两部取得巨大成功的基础上，第三部将故事推向更加宏大的宇宙尺度。导演郭帆表示，这一部将深入探讨人类文明在宇宙中的位置，视觉效果也将全面升级。

现实主义题材同样令人期待。《热辣滚烫》的续集正在紧锣密鼓地制作中，贾玲将继续用她独特的视角讲述小人物的故事。而陈思诚导演的新作《解密》，则将目光投向了谍战题材。

动画电影领域，《哪吒3》和《深海2》的相继定档让国漫迷们兴奋不已。这些作品不仅在技术上持续突破，在故事深度和情感表达上也达到了新的高度。

悬疑类型同样精彩。曹保平导演的《涉过愤怒的海》续集和忻钰坤导演的新作，都将为观众带来烧脑又震撼的观影体验。

此外，还有多部文艺片和纪录片值得关注。王小帅导演的新作、贾樟柯导演的纪录片项目，都将为中国电影注入更多人文关怀和艺术气息。

总的来看，2026年的国产电影呈现出类型丰富、质量提升的良好态势。无论是商业大片还是文艺佳作，都值得影迷们走进电影院去感受大银幕的魅力。`,
    tags: ['国产电影', '2026电影', '电影推荐', '流浪地球3', '哪吒3'],
    relatedArticles: ['a3', 'a6'],
  },
  a2: {
    content: `近年来，古装剧始终是中国电视剧市场的主力军。从《琅琊榜》到《庆余年》，从《长安十二时辰》到《繁城之下》，古装剧凭借其独特的魅力持续霸占荧屏。

那么，古装剧为何能在中国电视剧市场中长盛不衰呢？

首先，服化道的精良制作是古装剧吸引观众的第一要素。当代古装剧在服装、化妆、道具方面的投入越来越大，力求还原历史真实面貌。《长安十二时辰》中对于唐代长安城的还原，《清平乐》中对于宋代宫廷生活的呈现，都展现了制作团队对细节的极致追求。

其次，剧本创作水平的提升为古装剧注入了灵魂。优秀的古装剧往往有着扎实的文学基础，或改编自经典小说，或是原创剧本但经过精心打磨。这些剧本不仅在情节上引人入胜，更在主题上具有深度和现实意义。

第三，演员选角的精准也是古装剧成功的关键。张若昀在《庆余年》中饰演的范闲、胡歌在《琅琊榜》中饰演的梅长苏，都成为了经典角色。演员与角色的高度契合，让观众产生了强烈的情感共鸣。

第四，导演风格的形成让古装剧呈现出百花齐放的态势。正午阳光的严谨大气、柠萌影业的创新活力、华策影视的商业敏锐，不同的制作公司带来了风格各异的古装作品。

最后，古装剧承载了中国传统文化的精神内核。侠义精神、家国情怀、君子之道，这些传统价值观通过古装剧的演绎深入人心，引发观众的民族自豪感。

综上所述，古装剧的魅力在于它将传统文化与现代审美完美结合，既满足了观众对历史的好奇，又提供了丰富的视觉享受和情感体验。这也是它能够持续霸占荧屏的根本原因。`,
    tags: ['古装剧', '电视剧分析', '庆余年', '琅琊榜', '中国电视剧'],
    relatedArticles: ['a1', 'a4'],
  },
  a3: {
    content: `从2015年的《大圣归来》到2025年的《哪吒之魔童闹海》，中国动画电影走过了非凡的十年之路。

2015年，《大圣归来》以9.56亿的票房成绩震惊了业界。这部电影证明了中国动画电影的商业潜力，也为后来的国漫崛起奠定了基础。导演田晓鹏用现代视角重新诠释了经典IP，在视觉呈现上大胆创新。

2019年，《哪吒之魔童降世》横空出世，以50亿+的票房成绩刷新了国产动画电影的纪录。"我命由我不由天"的呐喊不仅震撼了观众，也宣告了国漫新时代的到来。导演饺子对传统神话的颠覆性改编，让这个古老故事焕发出全新的生命力。

2023年，《深海》以其独特的水墨粒子动画技术惊艳了世界。田晓鹏导演花费七年时间打磨这部作品，创造了一种前所未有的视觉语言。虽然票房不及预期，但其在艺术探索上的勇气和成就值得铭记。

2024年，《白蛇：浮生》延续了追光动画对传统故事现代演绎的追求，在技术与情感的双重维度上都达到了新的高度。

2025年至2026年，国漫市场进一步繁荣。《哪吒3》、《大圣归来2》等重磅作品相继推出，中国动画电影的品质和影响力持续提升。

技术层面，中国动画人在粒子特效、水墨渲染、3D建模等领域不断突破，形成了独特的中式动画美学。故事层面，越来越多的创作者从中国传统文化中汲取灵感，用现代视角讲述中国故事。

国漫的崛起不是偶然，而是几代动画人持续努力的结果。从人才培养到产业建设，从技术积累到文化自信，中国动画正在走向世界舞台的中央。`,
    tags: ['国漫', '中国动画', '哪吒', '深海', '大圣归来'],
    relatedArticles: ['a1', 'a5'],
  },
  a4: {
    content: `中国综艺节目的发展历程，是一部从模仿到创新、从棚内到户外的进化史。

早期的中国综艺以棚内录制为主。《快乐大本营》、《天天向上》等节目以明星访谈和游戏互动为主要形式，在棚内搭建的固定场景中完成录制。这种模式制作成本可控，流程标准化，但内容形式相对单一。

2013年，《爸爸去哪儿》的开播标志着中国综艺进入真人秀时代。户外拍摄、真实场景、素人参与，为观众带来了全新的观看体验。随后，《奔跑吧兄弟》、《极限挑战》等户外真人秀节目相继爆红。

近年来，综艺节目的类型更加多元化。音乐类《歌手》、《中国好声音》持续迭代；选秀类《创造101》、《青春有你》掀起偶像热潮；慢综艺《向往的生活》、《中餐厅》以其治愈温暖的风格赢得观众喜爱；推理类《明星大侦探》、《密室大逃脱》则满足了年轻人对烧脑体验的追求。

2025年后，综艺节目进一步向精品化和垂直化方向发展。《乘风破浪的姐姐》聚焦30+女性力量，《种地吧》关注农业和乡村振兴，《我可以47》探索极限运动领域。这些节目不仅在娱乐性上表现出色，更承载了社会价值和人文关怀。

技术层面，4K超高清、AI剪辑、VR沉浸式体验等新技术的应用，为综艺节目带来了更多可能性。

展望未来，中国综艺节目的创新方向将更加注重内容深度、社会价值和技术融合。从棚内录制到户外真人秀，从单一模式到多元发展，中国综艺正在书写属于自己的精彩篇章。`,
    tags: ['综艺节目', '真人秀', '娱乐产业', '中国综艺', '节目创新'],
    relatedArticles: ['a2', 'a6'],
  },
  a5: {
    content: `在这个信息爆炸的时代，纪录片以其真实、深刻的叙事方式，为我们打开了一扇了解世界的窗口。以下是五部值得反复观看的宝藏纪录片。

一、《地球脉动 第三季》
BBC出品的自然纪录片巅峰之作。从深海到高山，从极地到沙漠，这部纪录片用震撼的4K画面展现了地球生命的壮丽多样。大卫·爱登堡爵士的旁白更是让整部作品充满了敬畏与感动。

二、《河西走廊》
一部讲述中国西部历史与文化的纪录片。从张骞出使西域到丝绸之路的繁荣，从历史变迁到文化交融，这部纪录片用精美的画面和深情的叙事，展现了河西走廊两千年的辉煌历史。

三、《舌尖上的中国》
中国美食纪录片的开山之作。从南到北，从东到西，《舌尖上的中国》不仅展示了中国各地的美食文化，更通过食物讲述了中国人对生活、对家庭、对故乡的深厚情感。

四、《航拍中国》
一部以空中视角俯瞰中国的地理纪录片。从东部沿海到西部高原，从北国雪原到南部热带，《航拍中国》用震撼的航拍镜头展现了中国大地的壮美景观。

五、《人类宇宙》
从宇宙大爆炸到人类文明的诞生，这部纪录片将科学与哲学完美融合。它不仅讲述了宇宙的演化历史，更探讨了人类在宇宙中的位置和意义。

这五部纪录片，每一部都是一场视觉与思想的盛宴。它们让我们看到世界的宏大与精微，也让我们更加珍惜这个美丽的星球。`,
    tags: ['纪录片', '地球脉动', '河西走廊', '舌尖上的中国', '航拍中国'],
    relatedArticles: ['a3', 'a1'],
  },
  a6: {
    content: `在众多免费观影平台中，糖心视频凭借出色的产品体验和丰富的内容资源脱颖而出，成为越来越多用户的首选。

一、高清不缓冲的播放体验
糖心视频采用先进的视频编码和CDN加速技术，确保用户在任何网络环境下都能享受流畅的观影体验。4K高清专区更是为追求极致画质的用户提供了最佳选择。

二、海量内容资源
糖心视频拥有超过10万部影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等多种类型。无论是热门新片还是经典老剧，用户都能在这里找到想看的内容。

三、完全免费的商业模式
与其他平台不同，糖心视频坚持完全免费的模式。用户无需购买会员、无需付费订阅，即可观看所有内容。这种用户友好的策略赢得了广泛好评。

四、智能推荐算法
基于AI技术的智能推荐系统，能够根据用户的观看历史和偏好，精准推荐感兴趣的内容，让用户发现更多好片。

五、极简的产品设计
糖心视频的界面设计简洁直观，没有繁杂的广告和弹窗。用户可以快速找到想看的内容，获得纯粹、沉浸的观影体验。

六、多终端覆盖
支持手机、平板、电脑、智能电视等多种终端，用户可以在任何设备上随时观看。账号云端同步，追剧进度自动保存。

正是这些优势，让糖心视频在竞争激烈的视频平台市场中脱颖而出，成为超过5000万用户的追剧首选。未来，糖心视频将继续优化产品体验，为用户带来更好的服务。`,
    tags: ['糖心视频', '免费视频', '观影平台', '在线影视', '视频推荐'],
    relatedArticles: ['a1', 'a2'],
  },
};

export default function ArticlePage() {
  const { id } = useParams<{ id: string }>();
  const article = articles.find(a => a.id === id);
  const content = id ? articleContent[id] : null;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [id]);

  if (!article || !content) {
    return (
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-20 text-center">
            <h1 className="font-heading text-2xl font-bold text-foreground-900 mb-4">文章未找到</h1>
            <Link to="/" className="text-primary-500 hover:text-primary-600 font-medium cursor-pointer">返回首页</Link>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  const relatedArticles = content.relatedArticles
    .map(rid => articles.find(a => a.id === rid))
    .filter(Boolean) as typeof articles;

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: article.categoryName, href: `/category/${article.category}` },
    { label: article.title },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": article.title,
            "description": article.excerpt,
            "author": { "@type": "Person", "name": article.author },
            "datePublished": article.date,
            "url": `https://tangxin.com/article/${article.id}`,
            "publisher": {
              "@type": "Organization",
              "name": "糖心视频",
              "url": "https://tangxin.com"
            },
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://tangxin.com" },
                { "@type": "ListItem", "position": 2, "name": article.categoryName, "item": `https://tangxin.com/category/${article.category}` },
                { "@type": "ListItem", "position": 3, "name": article.title }
              ]
            }
          })
        }}
      />
      <Navbar />
      <main className="pt-20">
        <article className="max-w-[900px] mx-auto px-4 md:px-6 py-8">
          <Breadcrumb items={breadcrumbItems} />

          <header className="mt-6 mb-8">
            <span className="inline-block bg-accent-500 text-background-50 text-xs px-3 py-1 rounded-full font-medium mb-4">
              {article.categoryName}
            </span>
            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4 leading-tight">
              {article.title}
            </h1>
            <div className="flex items-center gap-4 text-sm text-foreground-500">
              <span className="flex items-center gap-1">
                <i className="ri-user-line"></i> {article.author}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-calendar-line"></i> {article.date}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-eye-line"></i> {article.views} 阅读
              </span>
            </div>
          </header>

          <div className="relative aspect-[16/9] rounded-xl overflow-hidden mb-8">
            <img
              src={article.imageUrl}
              alt={article.title}
              className="w-full h-full object-cover"
              title={article.title}
            />
          </div>

          <div className="prose prose-lg max-w-none">
            {content.content.split('\n\n').filter(Boolean).map((paragraph, index) => (
              <p key={index} className="text-foreground-700 leading-relaxed mb-5 text-[15px]">
                {paragraph.trim()}
              </p>
            ))}
          </div>

          <div className="flex items-center flex-wrap gap-2 mt-8 pt-6 border-t border-background-200">
            <span className="text-sm text-foreground-500 mr-2">标签：</span>
            {content.tags.map((tag) => (
              <span
                key={tag}
                className="bg-background-100 text-foreground-600 text-xs px-3 py-1.5 rounded-full"
              >
                {tag}
              </span>
            ))}
          </div>

          {relatedArticles.length > 0 && (
            <section className="mt-12 pt-8 border-t border-background-200">
              <h3 className="font-heading text-xl font-bold text-foreground-900 mb-5">相关文章</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {relatedArticles.map((ra) => (
                  <Link
                    key={ra.id}
                    to={`/article/${ra.id}`}
                    className="flex gap-4 p-4 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer bg-background-50"
                  >
                    <div className="w-24 h-16 rounded-lg overflow-hidden flex-shrink-0">
                      <img
                        src={ra.imageUrl}
                        alt={ra.title}
                        className="w-full h-full object-cover"
                        title={ra.title}
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h4 className="font-heading font-semibold text-sm text-foreground-900 line-clamp-2 leading-snug mb-1">
                        {ra.title}
                      </h4>
                      <span className="text-xs text-foreground-500">{ra.date}</span>
                    </div>
                  </Link>
                ))}
              </div>
            </section>
          )}
        </article>
      </main>
      <Footer />
    </div>
  );
}